<script lang="ts">
  import { Button } from '@athena-lib/Button';
  import { getCommonTranslations } from '@athena-lib/commonTranslationsContext';
  import { Text } from '@athena-lib/Text';
  import { usePromise } from '@athena-lib/usePromise.svelte';
  import clsx from 'clsx';
  import Spinner from '@athena-lib/Icons/Spinner.svelte';
  import type { CheckoutSdk } from '@athena-lib/Checkout/utils';
  import AddressFields from '@athena-lib/Checkout/AddressFields.svelte';
  import HeadingMedium from '@athena-lib/Text/HeadingMedium/HeadingMedium.svelte';
  import { useCheckoutForm } from '@athena-lib/Checkout/checkoutForm.svelte';
  import type { CheckoutErrors } from '@athena-lib/Checkout/Checkout.svelte';
  import { checkoutDrawerActions } from '$lib/utilities/checkoutDrawerContext.svelte';
  import { getCheckoutCountries } from '$lib/checkout.svelte';
  const { checkoutSdk }: { checkoutSdk: CheckoutSdk } = $props();

  let errors = $state<CheckoutErrors>({ userDetailsForm: {} });

  const translations = getCommonTranslations();
  let savePromise = $state<Promise<unknown> | null>(null);
  const savePromiseState = usePromise(() => savePromise);
  const formFields = useCheckoutForm(() => checkoutSdk, errors, translations);
</script>

{#snippet saveButtonText()}
  {#if savePromiseState.type === 'loading'}
    <Spinner sizeClass={clsx('h-5 w-5')} />
  {:else if savePromiseState.type === 'initial'}
    {translations.save}
  {:else if savePromiseState.type === 'rejected'}
    {translations.anErrorHasOccured}
  {:else if savePromiseState.type === 'resolved'}
    {translations.success}
  {/if}
{/snippet}

<div class="flex h-full flex-col px-5 pb-5 pt-14 text-center">
  <HeadingMedium size="small">{translations.chooseYourLocation}</HeadingMedium>
  <Text>{translations.enterYourAddress}</Text>
  <form id="location" class="mt-7 flex flex-col gap-4" onsubmit={() => {}}>
    <AddressFields
      type={'shipping'}
      {formFields}
      countries={getCheckoutCountries()}
      updateCountry={checkoutSdk.updateCountry}
      checkoutCountry={checkoutSdk.state.countryCode}
      hideNameFields
    />
  </form>
  <div class="mt-auto flex justify-center">
    <Button
      onClick={checkoutDrawerActions.close}
      form="location"
      disabled={savePromiseState.type === 'loading'}
      class="flex items-center justify-center">{@render saveButtonText()}</Button
    >
  </div>
</div>
